'use strict';

var _classCallCheck = require("/home/circleci/repo/projects/idea-hub-client/node_modules/@babel/runtime/helpers/classCallCheck");

module.exports = function Dir(props, _options) {
  _classCallCheck(this, Dir);

  this._options = _options || {};
  Object.assign(this, props);
};